/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import signupTemplate from './signup.tpl.html';
import emailVerificationTemplate from './email-verification.tpl.html';
import emailVerifiedTemplate from './email-verified.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function SignUpRoutes($stateProvider) {

    $stateProvider.state('signup', {
        url: '/signup',
        module: 'public',
        views: {
            "@": {
                controller: 'SignUpController',
                controllerAs: 'vm',
                templateUrl: signupTemplate
            }
        },
        data: {
            pageTitle: 'signup.signup'
        },
        resolve: {
            /*@ngInject*/
            signupParams: function(selfRegistrationService) {
                return selfRegistrationService.isAvailablePage()
            }
        }
    }).state('signup.emailVerification', {
        url: '/emailVerification?email',
        module: 'public',
        views: {
            "@": {
                controller: 'EmailVerificationController',
                controllerAs: 'vm',
                templateUrl: emailVerificationTemplate
            }
        },
        data: {
            pageTitle: 'signup.email-verification'
        }
    }).state('signup.emailVerified', {
        url: '/emailVerified?emailCode',
        module: 'public',
        views: {
            "@": {
                controller: 'EmailVerifiedController',
                controllerAs: 'vm',
                templateUrl: emailVerifiedTemplate
            }
        },
        data: {
            pageTitle: 'signup.account-activation-title'
        }
    });
}